<!--
 <CustomMoneyInput
    :value="formData.supplyPrice" // 父组件传入值
    :disabled="disabled" // 是否禁用
    :limitNum="limitNum" // 小数位数限制
    @change-emit="val=>formData.supplyPrice=val" // 返回input值
  />
 -->
<template>
  <div class="cml-custom-input">
    <el-input
      ref="inp"
      v-model="selectValue"
      :disabled="disabled"
      size="mini"
      :clearable="clearable"
      :maxlength="maxlength"
      :placeholder="placeholder"
      @keyup.native="keyupEvent($event)"
      @blur="keyupEvent($event)"
      @clear="clearValue"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: {
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    limitNum: {
      type: Number,
      default: 2,
    },
    maxlength: {
      type: Number,
      default: 14,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    // 负整数
    isNegativeInt: {
      type: Boolean,
      default: false,
    },
    // 负小数
    isNegativeFloat: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data: vm => ({
    selectValue: vm.value,
  }),
  watch: {
    value(val) {
      this.selectValue = val;
    },
  },
  methods: {
    keyupEvent(e) {
      if (this.limitNum === 3) {
        e.target.value = e.target.value.replace(/[^\d.]/g, '');
        e.target.value = e.target.value.replace(/\.{3,}/g, '.');
        e.target.value = e.target.value.replace(/^\./g, '0.');
        e.target.value = e.target.value.replace(
          /^\d*\.\d*\./g,
          e.target.value.substring(0, e.target.value.length - 1),
        );
        e.target.value = e.target.value.replace(
          /\D*(\d*)(\.?)(\d{0,3})\d*/,
          '$1$2$3',
        );
      } else if (this.limitNum !== 2) {
        // 整数
        const reg = this.isNegativeInt ? /[^\-|\d]/g : /[^\d]/g;
        e.target.value = e.target.value.replace(reg, '');
        e.target.value = e.target.value.replace('.', '');
      } else {
        // 两位小数
        e.target.value = e.target.value.replace(/[^\-|\d.]/g, '');
        e.target.value = e.target.value.replace(/\.{2,}/g, '.');
        e.target.value = e.target.value.replace(/^\./g, '0.');

        e.target.value = e.target.value.replace(
          /^\d*\.\d*\./g,
          e.target.value.substring(0, e.target.value.length - 1),
        );
        // 正数
        if (e.target.value >= 0) {
          e.target.value = e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2');
        } else {
          // 负数
          if (this.isNegativeFloat) {
            // 转为正数
            const reg = this.isNegativeInt ? /[^\-|\d]/g : /[^\d]/g;
            e.target.value = e.target.value.replace(reg, '');
            e.target.value = e.target.value.replace('.', '');
          } else {
            e.target.value = e.target.value.replace(
              /^(-\d+)\.(\d\d).*$/,
              '$1.$2',
            );
          }
        }
      }
      this.$emit('change-emit', e.target.value);
      e.type === 'blur' && this.$emit('on-blur');
    },
    clearValue() {
      this.$emit('change-emit', '');
    },
  },
};
</script>
<style lang="less" scoped>
.cml-custom-input {
  display: inline-block;
}
</style>
